export default __webpack_public_path__ + "static/rest-d3fccd3e9bfd28ce23b5f7b441859acd.gif";